import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

export const onAIAnswerDialogUnmount: ({
	isReadingAids,
	sourceProduct,
	dwellTime,
	loadTime,
	fmpLoadTime,
	...props
}: commonAttributesType & {
	isReadingAids: boolean;
	searchSessionId: string;
	source: string;
	sourceProduct?: string;
	dwellTime?: number;
	loadTime?: number;
	fmpLoadTime?: number;
}) => AnalyticsEventPayload = ({
	isReadingAids,
	sourceProduct,
	dwellTime,
	loadTime,
	fmpLoadTime,
	...props
}: commonAttributesType & {
	isReadingAids: boolean;
	searchSessionId: string;
	source: string;
	sourceProduct?: string;
	dwellTime?: number;
	loadTime?: number;
	fmpLoadTime?: number;
}): AnalyticsEventPayload => {
	const { query, source, searchSessionId } = props;
	return {
		action: 'unmounted',
		actionSubject: 'aiAnswerDialog',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			aiFeatureName: isReadingAids
				? `Definitions ${sourceProduct ? `(${sourceProduct})` : ''}`
				: 'smartAnswers',
			aiInteractionId: isReadingAids ? undefined : searchSessionId,
			aiInteractionType: isReadingAids ? undefined : 'searchSessionId',
			dwellTime,
			loadTime,
			fmpLoadTime,
		},
		nonPrivacySafeAttributes: {
			query,
		},
	};
};
